import { useState, useEffect } from 'react';
import { Table, DatePicker, Button, Modal, Form, Input, Tag } from 'antd';
import {createData, getData} from '../api/api';
import {SearchOutlined} from "@ant-design/icons";
const { Search } = Input;
const MccCodes = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60, // Aniqlik uchun kenglik
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'Mcc Kod', dataIndex: 'code', key: 'code', width: 100 },
        { title: 'Nomi (uz)', dataIndex: 'nameUz', key: 'nameUz', width: 200 },
        { title: 'Nomi (ru)', dataIndex: 'nameRu', key: 'nameRu', width: 200 },
        { title: 'Nomi (en)', dataIndex: 'nameEn', key: 'nameEn', width: 200 },
        { title: 'Order', dataIndex: 'order', key: 'order', width: 80 },
        { title: 'Icon', dataIndex: 'icon', key: 'icon', width: 80 },
        {
            title: 'Holati',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? (
                    <Tag color="green">Faol</Tag>
                ) : (
                    <Tag color="red">Nofaol</Tag>
                ),
        },

        {
            title: 'Amallar',
            key: 'actions',
            width: 200,
            render: (_, record) => (
                <>
                    <Button size="small" onClick={() => handleUpdate(record)}>
                        O'zgartirish
                    </Button>
                    {/*<Button size="small" danger onClick={() => handleDelete(record.id)} style={{ marginLeft: 8 }}>*/}
                    {/*    O'chirish*/}
                    {/*</Button>*/}
                </>
            ),
        },
    ];

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData('/admin/mcc-code-list-by-filter', {
                page: pagination.current - 1, // Backend uchun 0 dan boshlanadi
                size: pagination.pageSize,
                status: -1, // Default status
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [pagination.current, pagination.pageSize, filters]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 }); // Filtr o'zgarganda 1-sahifaga qaytish
    };

    const handleCreate = async (values) => {
        try {
            const response = await createData("/admin/mcc-code/create", values);
            if (response?.data?.success && response?.data?.data) {
                fetchData();
                handleCancel();
            } else {
                alert(response?.data?.error?.text || "Mcc kod qo'shishda xatolik")
            }
        } catch (error) {
            console.error(error);
            alert("Mcc kod qo'shishda xatolik");
        }
    };

    const handleUpdate = async (record) => {
        setCurrentRecord(record);
        updateForm.setFieldsValue({
            code: record.code,
            nameUz: record.nameUz,
            nameRu: record.nameRu,
            nameEn: record.nameEn,
            status: record.status,
            order: record.order,
            icon: record.icon
        });
        setIsUpdateModalVisible(true);
    };

    const handleUpdateSubmit = async (values) => {
        try {
            const response = await createData('/admin/mcc-code/update', {
                ...values,
                code:currentRecord.code
            });
            if (response?.data?.success && response?.data?.data) {
                fetchData();
                handleUpdateCancel();
            } else {
                alert(response?.data?.error?.text || "Mcc kod o'zgartirshda xatolik");
            }
        } catch (error) {
            console.error(error);
            alert("Mcc kod o'zgartirshda xatolik");
        }
    };

    const handleDelete = async (id) => {
        // await deleteData('/dashboard', id);
        // fetchData();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };
    const handleUpdateCancel = () => {
        setIsUpdateModalVisible(false);
        updateForm.resetFields();
        setCurrentRecord(null);
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Mcc Kodlar</h2>
                <Button type="primary" onClick={showModal}>
                    Mcc qo'shish
                </Button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                <Search
                    placeholder={"Code , name bo'yicha qidirish..."}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="middle"
                    style={{ width: 300 }}
                    onSearch={(value) => handleFilter({ ...filters, search: value })}
                />
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => `Jami: ${total} ta`,
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }} // Gorizontal scroll uchun
            />

            {/*Qo'shish modal*/}
            <Modal
                title="Mcc kod qo'shish"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="code"
                        label="Mcc kod"
                        rules={[{ required: true, message: "Mcc kod kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="nameUz"
                        label="Nomi (uz)"
                        rules={[{ required: true, message: "Nomi (uz) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="nameRu"
                        label="Nomi (ru)"
                        rules={[{ required: true, message: "Nomi (ru) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="nameEn"
                        label="Nomi (en)"
                        rules={[{ required: true, message: "Nomi (en) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="order"
                        label="Navbat (Order)"
                    >
                        <Input type={"number"}/>
                    </Form.Item>

                    <Form.Item
                        name="icon"
                        label="Icon"
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>



            {/*O'zgartirish modal*/}
            <Modal
                title="Mcc kod o'zgartirish"
                visible={isUpdateModalVisible}
                onCancel={handleUpdateCancel}
                footer={null}
            >
                <Form form={updateForm} onFinish={handleUpdateSubmit} layout="vertical">
                    <Form.Item
                        name="code"
                        label="Mcc kod"
                        rules={[{ required: true, message: "Mcc kod kiriting!" }]}
                    >
                        <Input disabled={true}/>
                    </Form.Item>

                    <Form.Item
                        name="nameUz"
                        label="Nomi (uz)"
                        rules={[{ required: true, message: "Nomi (uz) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="nameRu"
                        label="Nomi (ru)"
                        rules={[{ required: true, message: "Nomi (ru) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="nameEn"
                        label="Nomi (en)"
                        rules={[{ required: true, message: "Nomi (en) kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="order"
                        label="Navbat (Order)"
                    >
                        <Input type={"number"}/>
                    </Form.Item>

                    <Form.Item
                        name="icon"
                        label="Icon"
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default MccCodes;